<template>
  <div>
    <v-row :dense="$vuetify.breakpoint.smAndDown" v-if="!loading && items">
      <v-col v-for="item in items" :key="item.id" :lg="cols" :md="cols" class="px-2 pb-0" cols="6" sm="4">
        <ItemCardDefault :value="item" @add="$emit('add', item)"/>
      </v-col>
    </v-row>
    <v-row dense v-if="loading || fetching">
      <v-col :key="i" :lg="cols" :md="cols" cols="6" sm="4" v-for="i in 2">
        <ItemCardLoading/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ItemCardDefault from "../templates/elements/ItemCardDefault";
import ItemCardLoading from "../templates/elements/ItemCardLoading";
import list from "../../mixins/items/list";

export default {
  name: 'ProductListVerticalCards',
  components: { ItemCardLoading, ItemCardDefault },
  mixins: [list]
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-skeleton-loader__list-item-three-line.v-skeleton-loader__bone {
    background: none;
  }
}
</style>
